import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import CssVariables from '../../theme/variables/CssVariables.js';
import Tooltip from './../../external_lib/antd/es/tooltip/index.js';
function HorizonTooltip(_a) {
  _a.className;
  var restProps = __rest(_a, ["className"]);
  return React__default.createElement(Tooltip, __assign({
    placement: "topLeft",
    overlayInnerStyle: {
      color: CssVariables['--up-black-60'],
      backgroundColor: CssVariables['--up-black-0'],
      minHeight: '24px',
      padding: '4px 8px',
      fontSize: '12px',
      lineHeight: '16px',
      boxShadow: CssVariables['--box-shadow-dark-dialog']
    },
    color: CssVariables['--up-black-0']
  }, restProps));
}
export { HorizonTooltip as default };
//# sourceMappingURL=index.js.map
